import React from "react";
import Text from "../../components/typography/Text";
import Tags from "../../components/tags/Tags";
import typesContext from "../../contexts/types";

export default ({ title, description, month, year, skill, image }) => {
  const { skills, months } = React.useContext(typesContext);

  const { label: monthString } =
    months.find(({ value }) => month === value) || {};

  const designerSkills =
    skills && skill
      ? skill
          .map(skillId => {
            const skillData = skills.find(({ id }) => id === skillId);
            return skillData ? skillData.name : null;
          })
          .filter(Boolean)
      : [];

  return (
    <div className="oDesignerProjectDetails">
      <div className="oDesignerProjectDetails_infos">
        <h4>{title.rendered}</h4>
        <Text small>{description}</Text>
        <Text superSmall style={{ color: "#949494" }}>
          {monthString}, {year}
        </Text>
      </div>
      <div className="oDesignerProjectDetails_skills">
        <h5>Skills</h5>
        <Tags tags={designerSkills} />
      </div>
    </div>
  );
};
